import { render } from "./AnimalHealth.vue?vue&type=template&id=59798f30"
import script from "./AnimalHealth.vue?vue&type=script&lang=js"
export * from "./AnimalHealth.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__